import { clearSelectedContactID } from "../redux/Slice/Inbox/inboxAllSlice";
import { clearMessages } from "../redux/Slice/Inbox/InboxMessageSlice";
import { clearContactInfo } from "../redux/Slice/Inbox/inboxInfoSlice";
import { clearCurrentChat } from "../redux/Slice/Inbox/teamMemberChatSlice";
import { clearActiveChat } from "./socketHandler";

/**
 * Clears customer chat selection, messages, contact info, team thread, and socket active chat.
 * Call this when the inbox sidebar filter tab changes so URL/main pane stay in sync (same as InboxAll tab effect).
 */
export function dispatchInboxSidebarTabChangeClear(dispatch) {
  console.warn("[DL-TRACE] dispatchInboxSidebarTabChangeClear", new Error().stack);
  dispatch(clearSelectedContactID());
  dispatch(clearMessages());
  clearActiveChat();
  dispatch(clearCurrentChat());
  dispatch(clearContactInfo());
}

/**
 * Navigates off /chat/:contactId when present so MessageCard URL sync cannot re-select the previous contact.
 */
export function navigateOffCustomerChatRoute(navigate, accountid, effectiveUserid) {
  if (
    !effectiveUserid ||
    !accountid ||
    typeof window === "undefined" ||
    !window.location.pathname.includes("/chat/")
  ) {
    return;
  }
  console.warn("[DL-TRACE] navigateOffCustomerChatRoute", new Error().stack);
  navigate(`/home/${accountid}/inbox/${effectiveUserid}`, { replace: true });
}
